
	import { Component, Vue } from 'vue-property-decorator'
	import BaseVue from '@/components/BaseVue'
	import appBar from '@/components/AppBar.vue'
	import { Authority } from '../models/Authority'
	import { WorkingList } from '../models/WorkingList'
	import { MonthlyData } from '../models/MonthlyData'
	import { MonthlyCostTrainPassData} from '../models/MonthlyCostTrainPassData'
	import { SearchCondition } from '../models/WorkingListSearchCondition'
	import { LogData } from '../models/LogData'
    import { Const } from '../scripts/Const'
    import { MsgConst } from '../scripts/MsgConst'
    import { StringUtil } from '../scripts/StringUtil'

@Component({
	components: { appBar }
})
export default class WorkingListView extends BaseVue {
	//#region 変数
	private authority: Authority = new Authority()
	private monthlyData: MonthlyData = new MonthlyData()
	private monthlyCostTrainPassData: MonthlyCostTrainPassData = new MonthlyCostTrainPassData();
	private workingList: WorkingList[] = []
	private searchCondition: SearchCondition = new SearchCondition()
	//private logs: LogData = new LogData()
    private logs: LogData[] = []
	private eventNm = ''
	private selectDate: string[] = []
    private chkTravelCost = false
	private menu = false

	//#region  ヘッダー
	private workingHeader = [
		{
			value: 'data-table-select',
			width: '3%',
            class: 'sticky1 row-z sticky-header pa-0 d-print-none',
			align: 'left'
		},
		{
			text: '日付',
			value: 'workingDate',
			width: '3%',
			class: 'sticky2 row-z sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			value: 'weekDay',
			width: '3%',
			class: 'sticky3 row-z sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			value: 'holidaySnm',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '出勤',
			value: 'wkTimeStart',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '退勤',
			value: 'wkTimeEnd',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '休憩',
			value: 'restTimeTotal',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '稼働',
			value: 'wktimeActual',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '休暇',
			value: 'vacationSnm',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '遅早',
			value: 'tardyEarly',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '振替',
			value: 'exchangeDate',
			width: '6%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '残業',
			value: 'wktimeOvertime',
			width: '6%',
			class: 'sticky-header success white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '深夜',
			value: 'ektimeMidnight',
			width: '6%',
			class: 'sticky-header success white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '法定',
			value: 'wktimeLegalHoliday',
			width: '6%',
			class: 'sticky-header success white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '在',
			value: 'teleSnm',
			width: '4%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: 'S',
			value: 'WorkingSnm',
			width: '4%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
		{
			text: '特記事項',
			value: 'workingRemarks',
			width: '14%',
			class: 'sticky-header primary white--text px-1',
			sortable: false,
			align: 'center'
		},
        {
            text: '経費金額',
            value: 'costAmount',
            width: '8%',
            class: 'sticky-header primary white--text px-1',
            sortable: false,
            align: 'center'
		},
        {
            text: '',
            value: 'workingRemarks',
            width: '6%',
            class: 'sticky-header primary white--text px-1',
            sortable: false,
            align: 'center'
		}
	]
	//#endregion

	//#region 表示制御
	private showRequest = false
	private showCacnel = false
	private showConfirm = false
	private showApproval = false
	private showReject = false
	private showClose = false
	private showCloseMonthly = false
	private showCancelClose = false
	private showDecisionRemarks = false
	//#endregion

	//#region 活性制御
	private disableRequest = false
	private disableCancel = true
	private disableConfirm = false
	private disableApproval = false
	private disableReject = false
	private disableCheck = false
	//#endregion

	//#region メッセージ
	private showMessage = false
	private messageType = 'info'
	private message = ''
	//#endregion

	//#region ダイアログ
	private dialog = false
	private confirmationDialog = false
	private title = ''
	private dialogMsg = ''
	//#endregion

	//#region スナックバー
    private showSnackbar = false
    private snackbarMsg = ''
	//#endregion

    private reportYM = ''

	//#endregion

	// == イベント == //

	// #region 初期表示
	private async created() {
		//チェックボックス初期化
		this.selectDate = []

		this.searchCondition.workingYm = this.$route.params.workingYm
		this.searchCondition.empCd = this.$route.params.empCd
		this.searchCondition.beforeViewName = this.$route.params.beforeViewName
		this.searchCondition.beforeViewParam1 = this.$route.params.beforeViewParam1
		this.searchCondition.beforeViewParam2 = this.$route.params.beforeViewParam2
		this.searchCondition.beforeViewParam3 = this.$route.params.beforeViewParam3
		//検索
		this.getWorkingList()
	}
	//#endregion

	//#region 申請ボタン押下
	private clickApply() {
		//確認ダイアログ
		this.eventNm = 'apply'

		//役員の場合、そのまま承認
		if (this.authority.empTypeCd === Const.Emptype.EXECTIVE) {
            this.eventNm = 'approvalMonthly'
        }

		this.showDecisionRemarks = false;
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_002, '勤務表'))
	}
	//#endregion

	//#region 取消ボタン押下
	private clickCancel() {
		//確認ダイアログ
		this.eventNm = 'cancel'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_003, '勤務表'))
	}
	//#endregion

	//#region 確認ボタン押下
	private clickConfirm() {
		if (this.selectDate.length > 0) {
			//チェックしている場合
			this.eventNm = 'confirmDaily'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_004, '指定した日付の勤務時間'))
		} else {
			//チェックしていない場合
			this.eventNm = 'confirmMonthly'
			this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_004, '勤務表'))
		}
	}
	//#endregion

	//#region 承認ボタン押下
	private clickApproval() {
		if (this.selectDate.length > 0) {
			//チェックしている場合
			this.eventNm = 'approvalDaily'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_005, '指定した日付の勤務時間'))
		} else {
			//チェックしていない場合
			this.eventNm = 'approvalMonthly'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_005, '勤務表'))
		}
	}
	//#endregion

	//#region 否認ボタン押下
	private clickReject() {
		if (this.selectDate.length > 0) {
			//チェックしている場合
			this.eventNm = 'reject'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_006, '指定した日付の勤務時間'))
		} else {
			//チェックしていない場合
			this.eventNm = ''
            this.openConfirmationDialog('エラー', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_016, '否認する日付'))
		}
	}
	//#endregion

	//#region 締めボタン押下
	private clickCloseMonthly() {
		if (this.selectDate.length > 0) {
			//チェックしている場合
			this.openConfirmationDialog('エラー', MsgConst.WORKING_LIST.ERROR_001)
		} else {
			//チェックしていない場合
			this.eventNm = 'closeMonthly'
			this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_007, '勤務表'))
		}
	}
	//#endregion

	//#region 締め解除ボタン押下
	private clickCancelClosing() {
		if (this.selectDate.length > 0) {
			//チェックしている場合
            this.openConfirmationDialog('エラー', MsgConst.WORKING_LIST.ERROR_002)
		} else {
			//チェックしていない場合
			this.eventNm = 'cancelClosing'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_008, '勤務表'))
		}
	}
	//#endregion

	//#region 戻るボタン押下
    private clickClose() {
        this.$store.commit('navigation/POP_HISTORY') // 現在画面を削除
        const previous = this.$store.getters['navigation/lastPage'] // ひとつ前を取得

        if (previous) {
            this.$router.push({
                name: previous.name,
                params: {
                    dateFrom: this.searchCondition.beforeViewParam1,
                    dateTo: this.searchCondition.beforeViewParam2,
					searchString: this.searchCondition.beforeViewParam3,
                    isBack: true
                }as any
            })
        } else {
            this.$router.push({ name: 'Menu' })
        }
    }
	//#endregion

	//#region 日付クリック
	private clickDate(date: string) {
		var workingDate = ''

		//YYYY-MM-DD形式に変換
		workingDate = this.monthlyData.workingYm + '-' + date

		this.$router.push({
			name: 'AttendanceEntry',
			params: {
				workingDate: workingDate,
				empCd: this.monthlyData.empCd,
				beforeViewName: this.searchCondition.beforeViewName,
				beforeViewParam1: this.searchCondition.beforeViewParam1,
				beforeViewParam2: this.searchCondition.beforeViewParam2,
				beforeViewParam3: this.searchCondition.beforeViewParam3
			}
		})
	}
	//#endregion

    //#region 定期情報クリック 定期券申請画面を開く
	private clickTrainPass() {

        this.$router.push({
            name: 'TrainPassApplication',
			params: {
				ym: StringUtil.changeMonth((this.monthlyData.workingYm).replace('-', ''),1),
                empCd: this.monthlyData.empCd,
                beforeViewName: 'WorkingList',
                beforeViewParam1: this.searchCondition.beforeViewParam1,
                beforeViewParam2: this.searchCondition.beforeViewParam2,
                beforeViewParam3: this.searchCondition.beforeViewParam3
            }
        })

    }
	//#endregion

	//#region 年月変更
	private changeYm() {
		//初期化
		this.selectDate = []
		this.clearMessage()
		//勤務表情報の取得
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd
		this.getWorkingList()
	}
	//#endregion

    //#region ＄アイコンクリック(日次)　経費一覧画面を開く
    private editItem(item: WorkingList) {

        var workingDate = ''
        var workingYm = ''
        //YYYYMMDD形式に変換
		workingYm = (this.monthlyData.workingYm).replace('-', '')
		workingDate = workingYm + item.workingDate

        this.$router.push({
            name: 'CostList',
            params: {
                monthlyKbn: '0',
				workingDate: workingDate,
                workingYm: workingYm,
                empCd: this.monthlyData.empCd,
                beforeViewName: 'WorkingList',
                beforeViewParam1: this.searchCondition.beforeViewParam1,
                beforeViewParam2: this.searchCondition.beforeViewParam2,
                beforeViewParam3: this.searchCondition.beforeViewParam3
            }
        })
    }
    //#endregion

    //#region ＄アイコンクリック（月度）　経費一覧画面を開く
    private editMonthlyItem() {

        var workingDate = ''
        var workingYm = ''
        //YYYYMMDD形式に変換
        workingYm = (this.monthlyData.workingYm).replace('-', '')
        workingDate = workingYm

        this.$router.push({
            name: 'CostList',
            params: {
                monthlyKbn: '1',
                workingDate: workingDate,
                workingYm: workingYm,
                empCd: this.monthlyData.empCd,
                beforeViewName: 'WorkingList',
                beforeViewParam1: this.searchCondition.beforeViewParam1,
                beforeViewParam2: this.searchCondition.beforeViewParam2,
                beforeViewParam3: this.searchCondition.beforeViewParam3
            }

        })
    }
	//#endregion

	//#region プライベート

	//#region 申請
	private apply() {
        this.clearMessage()
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd

		if (this.chkTravelCost == true) {
			this.monthlyData.warningKbn = '01'	//交通費あり
		} else {
            this.monthlyData.warningKbn = '00'	//交通費なし
        }
		//申請
		this.applyMonthly()
	}
	//#endregion

	//#region 取消
	private cancel() {
        this.clearMessage()
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd

		//取消
		this.cancelMonthly()
	}
	//#endregion

	//#region 勤務表確認
	private confirmM() {
        this.clearMessage()
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd

		//確認
		this.confirmMonthly()
	}
	//#endregion

	//#region 勤務時間確認
	private confirmD() {
        this.clearMessage()
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd

		//確認
		this.confirmDaily()
	}
	//#endregion

	//#region 勤務表承認
	private approvalM() {
        this.clearMessage()
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd

		//承認
		this.approvalMonthly()
	}
	//#endregion

	//#region 勤務時間承認
	private approvalD() {
        this.clearMessage()
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd

		//承認
		this.approvalDaily()
	}
	//#endregion

	//#region 勤務時間否認
	private reject() {
        this.clearMessage()
		this.searchCondition.workingYm = this.monthlyData.workingYm.replace('-', '')
		this.searchCondition.empCd = this.monthlyData.empCd

		//否認
		this.rejectDaily()
	}
	//#endregion

	//#region 勤務表情報取得
	private async getWorkingList() {
		try {
			const data = { SearchCondition: this.searchCondition }

			const response = await this.$axios.post('api/WorkingList/Get', data)

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (response.data.messageData.errFlg) {
                    return
                }
            }

			//権限
			this.authority = response.data.authority
			//勤務時間
			this.workingList = response.data.searchResult
			this.monthlyData = response.data.monthlyBasicData
            this.monthlyCostTrainPassData = response.data.monthlyCostTrainPassData
			//ログ
			this.logs = response.data.logList
			//表示制御
			this.displayControl()
			//要対応件数カウント
			this.countActionRequired()

			//印刷用表示年月
			this.reportYM = this.monthlyData.workingYm.substr(0, 4) + '年' + this.monthlyData.workingYm.substr(5, 2) + '月度勤務表'

			//申請時ダイアログ用チェックの有無(申請取消後の再申請時に機能する)
            if (this.monthlyData.warningKbn == '01') {
                this.chkTravelCost = true	//交通費あり
            } else {
                this.chkTravelCost = false	//交通費なし
            }

			//画面上部へスクロール
			window.scrollTo({ top: 0, behavior: 'smooth' })
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務表申請
	private async applyMonthly() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData
			}

			const response = await this.$axios.post('api/WorkingList/Apply', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務表取消
	private async cancelMonthly() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData
			}

			const response = await this.$axios.post('api/WorkingList/Cancel', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務表確認
	private async confirmMonthly() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData
			}

			const response = await this.$axios.post('api/WorkingList/ConfirmMontly', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
					this.selectDate = []
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務時間確認
	private async confirmDaily() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData,
				SelectDate: this.selectDate
			}

			const response = await this.$axios.post('api/WorkingList/ConfirmDaily', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
					this.selectDate = []
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務表承認
	private async approvalMonthly() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData,
                MonthlyCostTrainPassData: this.monthlyCostTrainPassData
			}

			const response = await this.$axios.post('api/WorkingList/ApprovalMontly', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
					this.selectDate = []
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務時間承認
	private async approvalDaily() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData,
				SelectDate: this.selectDate
			}

			const response = await this.$axios.post('api/WorkingList/ApprovalDaily', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
					this.selectDate = []
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務時間否認
	private async rejectDaily() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData,
				SelectDate: this.selectDate
			}

			const response = await this.$axios.post('api/WorkingList/Reject', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
					this.selectDate = []
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務表締め
	private async closeMonthly() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData
			}

			const response = await this.$axios.post('api/WorkingList/CloseMontly', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
					this.selectDate = []
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 勤務表締め解除
	private async cancelClosing() {
		try {
			const data = {
				SearchCondition: this.searchCondition,
				SearchResult: this.workingList,
				MonthlyBasicData: this.monthlyData
			}

			const response = await this.$axios.post('api/WorkingList/CancelClosing', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getWorkingList()
					this.selectDate = []
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#region 表示制御
	private displayControl() {
		if (this.monthlyData.empCd == this.authority.loginEmpCd || this.authority.roleManager) {
			//本人・管理職の場合
			this.showRequest = true

			if (this.monthlyData.empCd != this.authority.loginEmpCd && this.authority.roleManager) {
				//管理職権限ありの場合
				this.showConfirm = true
				this.showApproval = true
				this.showReject = true
				this.disableCheck = false
				this.showDecisionRemarks = true
			} else {
				this.showConfirm = false
				this.showApproval = false
				this.showReject = false
				this.disableCheck = true
			}

			//取消ボタン表示
			if (
				this.monthlyData.monthlyStatus == Const.MonthlyStatus.AWAITING_APPROVAL ||
				this.monthlyData.monthlyStatus == Const.MonthlyStatus.APPROVED ||
				this.monthlyData.monthlyStatus == Const.MonthlyStatus.CLOSING
			) {
				this.showCacnel = true
				this.showRequest = false
			} else {
				this.showRequest = true
				this.showCacnel = false
				this.disableRequest = false
			}
		} else {
			//本人・管理職以外
			this.disableCheck = true
            this.showRequest = false
            this.showCacnel = false
            this.showConfirm = false
            this.showApproval = false
			this.showReject = false
            this.showDecisionRemarks = true
			//総務
			if (this.authority.roleWorkingHoursAdmin) {
				null
			}
			//現場リーダー
			if (this.authority.roleLeader || this.authority.roleSales) {
                this.disableCheck = false
				this.showConfirm = true
			}
			//業務管理
			if (this.authority.roleBusinessAdmin) {
				null
			}
		}

		//締めボタン
		if (this.authority.roleWorkingHoursAdmin && this.monthlyData.monthlyStatus == Const.MonthlyStatus.APPROVED) {
			this.showCloseMonthly = true
			this.showCancelClose = false
		} else if (this.authority.roleWorkingHoursAdmin && this.monthlyData.monthlyStatus == Const.MonthlyStatus.CLOSING) {
			this.showCloseMonthly = false
			this.showCancelClose = true
		} else {
			this.showCloseMonthly = false
			this.showCancelClose = false
		}

		//締め済みの場合編集不可
		if (this.monthlyData.monthlyStatus == Const.MonthlyStatus.CLOSING) {
			this.disableCheck = true
			this.disableRequest = true
			this.disableCancel = true
			this.disableApproval = true
			this.disableConfirm = true
			this.disableReject = true
		} else if (this.monthlyData.monthlyStatus == Const.MonthlyStatus.APPROVED) {
			//承認済みの場合 取消不可
			this.disableCancel = true
			this.disableApproval = false
			this.disableConfirm = false
			this.disableReject = false
		} else {
			this.disableRequest = false
			this.disableCancel = false
			this.disableApproval = false
			this.disableConfirm = false
			this.disableReject = false
		}

	}
	//#endregion

	//#region 要対応項目カウント
	private countActionRequired() {
        msg = ''
		//本人
		/*if (this.monthlyData.empCd == this.authority.loginEmpCd) {*/
		var worktimeRemand = this.workingList.filter((x) => x.dailyStatus == Const.DailyStatus.REMAND)
		var requestRemand = this.workingList.filter(
			(x) => x.workingStatus == Const.DailyStatus.REMAND || x.vacationStatus == Const.RequestStatus.REMAND || x.tardyEarlyStatus == Const.RequestStatus.REMAND
				|| x.workingStatus == Const.DailyStatus.MAKING || x.vacationStatus == Const.RequestStatus.MAKING || x.tardyEarlyStatus == Const.RequestStatus.MAKING
				|| !x.vacationStatus && x.vacationKbn != Const.VacationKbn.DEFAULT || !x.tardyEarlyStatus && x.tardyEarly
			)

			if (worktimeRemand.length > 0) {
				msg = '勤務時間'
			}
			if (requestRemand.length > 0) {
                if (msg) {
                    msg += '・'
				}
				msg = msg + '申請:' + requestRemand.length + '件 \r\n'
			}
			if (msg) {
                this.showSnackbar = true
                this.snackbarMsg = '【本人】' + msg
			}
		//勤務表が差戻の場合
		if (this.monthlyData.monthlyStatus == Const.MonthlyStatus.REMAND) {
			this.errorMessage(MsgConst.WORKING_LIST.ERROR_003)
			}

        var msg = ''
        //管理職ログイン
		if (this.monthlyData.empCd != this.authority.loginEmpCd && this.authority.roleManager) {
			var worktime = this.workingList.filter((x) => x.dailyStatus == Const.DailyStatus.AWAITING_APPROVAL)
			var request = this.workingList.filter(
				(x) => x.workingStatus == Const.DailyStatus.AWAITING_APPROVAL || x.vacationStatus == Const.RequestStatus.AWAITING_APPROVAL || x.tardyEarlyStatus == Const.RequestStatus.AWAITING_APPROVAL
            )

            if (worktime.length > 0) {
                msg = '勤務時間'
            }
            if (request.length > 0) {
                if (msg) {
                    msg += '・'
                }
                msg = msg + '申請:' + request.length + '件 \r\n'
            }
            if (msg) {
				if (this.snackbarMsg) {
					this.snackbarMsg += '、'
				}
                this.snackbarMsg += '【管理職】' + msg
            }
        }

        if (this.snackbarMsg) {
            this.showSnackbar = true
        }
	}
	//#endregion

	//#region 土日祝カラー
	private holidayColor(kbn: string, week: string) {
		if (kbn == '所休' && week == '土') {
			return 'sticky3 col-z blue--text px-1 text-center'
		} else if (kbn == '所休') {
			return 'sticky3 col-z red--text px-1 text-center'
		} else if (kbn == '法休') {
			return 'sticky3 col-z red--text px-1 text-center'
		} else {
			return 'sticky3 col-z px-1 text-center'
		}
	}

	private trColor(kbn: string) {
		if (kbn == '所休') {
			return 'blue lighten-4'
		} else if (kbn == '法休') {
			return 'red lighten-4'
		} else {
			return 'white'
		}
	}
	//#endregion

	//#region 出退勤時間の背景色
	//出勤時間
	private startColor(shiftTime: string, startTime: string, workingKbn: string) {
		if ((workingKbn == Const.WorkingKbn.HOLIDAY_WORK || workingKbn == Const.WorkingKbn.INDIVIDUAL_SHIFT) && startTime != '') {
			return 'colorYellow px-1'
		} else if (shiftTime != startTime && startTime != '') {
			return 'colorYellow px-1'
		} else {
			return 'px-1 text-center'
		}
	}
	//退勤時間
	private endColor(shiftStartTime: string, shiftEndTime: string, endTime: string, workingKbn: string) {
		var sst = parseFloat(shiftStartTime)
		var set = parseFloat(shiftEndTime)
		var et = parseFloat(endTime)
		if ((workingKbn == Const.WorkingKbn.HOLIDAY_WORK || workingKbn == Const.WorkingKbn.INDIVIDUAL_SHIFT) && endTime != '') {
			return 'colorYellow px-1'
		} else if (set > et && sst < et) {
			return 'colorYellow px-1'
		} else {
			return 'px-1 text-center'
		}
	}
	//#endregion

	//#region 休憩時間の背景色
	//休憩時間
	private restColor(changeFlg: boolean) {
		if (changeFlg) {
			return 'colorYellow px-1 text-right'
		} else {
			return 'px-1 text-right'
		}
	}
	//#endregion

	//#region 申請の背景色
	//勤務時間
	private dailyStatusColor(status: string, holikbn: string, logcount: string) {
		if (holikbn == '平日') {
			if (status == Const.DailyStatus.REMAND) {
				//差戻
				return 'colorRed sticky2 col-z px-1'
			} else if (status == Const.DailyStatus.AWAITING_APPROVAL) {
				//申請中
				return 'colorOrange sticky2 col-z px-1'
			} else if (status == Const.DailyStatus.MAKING) {
				//作成中
                return 'colorGrey sticky2 col-z px-1'
            }else if (logcount) {
				//ログ情報がある場合
				return 'colorGreen sticky2 col-z px-1'
			} else if (status == Const.DailyStatus.APPROVED || status == Const.DailyStatus.CLOSING) {
				//承認済み・締済
				return 'colorWhite sticky2 col-z px-1'
			} else {
				//新規
				return 'colorGrey sticky2 col-z px-1'
			}
		} else {
			if (status == Const.DailyStatus.REMAND) {
				//差戻
				return 'colorRed sticky2 col-z px-1'
			} else if (status == Const.DailyStatus.AWAITING_APPROVAL) {
				//申請中
				return 'colorOrange sticky2 col-z px-1'
			} else if (status == Const.DailyStatus.MAKING) {
                //作成中
                return 'colorGrey sticky2 col-z px-1'
            }else if (logcount) {
				//ログ情報がある場合
				return 'colorGreen sticky2 col-z px-1'
			} else {
				return 'colorWhite sticky2 col-z px-1'
			}
		}
	}
	//申請系
	private requestColor(status: string, kbn: string) {
		//シフト2・3のときは背景白
		if (kbn == '1' || kbn == '2') {
			return 'px-1 text-center'
		}
		if (kbn && (status == Const.RequestStatus.REMAND || status == Const.RequestStatus.MAKING || !status)) {
			//差戻・作成中・未申請
			return 'colorRed px-1 '
		} else if (kbn && status == Const.RequestStatus.AWAITING_APPROVAL) {
			//申請中
			return 'colorOrange px-1 '
		} else if (kbn && (status == Const.RequestStatus.APPROVED || status == Const.RequestStatus.CLOSING)) {
			//承認締済
			return 'px-1 text-center'
		} else {
			return 'px-1 text-center'
		}
	}
	//#endregion

	//#region 経費金額の背景色
	private costColor(costCount: number, costRejectCount: number) {
		//交通費以外の経費が含まれる場合は背景黄色
        if (costRejectCount && costRejectCount > 0)
		{
            return 'colorRed px-1 text-right '
        }
		else if (costCount && costCount > 0) {
            return 'colorYellow px-1 text-right '
		} else {
            return'px-1 text-right '
        }
		
    }
	//#endregion

    //#region バス通勤有無の表示仕様
    private displayBusCommuteInfo(busCommuteFlg: boolean) {

        if (busCommuteFlg) {
            return 'バス通勤：利用あり';
        } else {
            return 'バス通勤：利用なし';
        }
    }
	//#endregion

    //#region 経費金額列の表示仕様
    private displayCostAmount(costAmount: number):string{

        //金額が0以上の場合のみ表示
		if (costAmount > 0) {
			return StringUtil.formatNumber(costAmount.toString());
        } else {
            return ''
        }

    }
	//#endregion

	//#region 経費金額列合計行の表示仕様
    private displaySumCostAmount(workingList: WorkingList[]): string {

        return StringUtil.formatNumber((workingList.reduce((total, workingDetail) => total + workingDetail.costAmount, 0)).toString());

    }
	//#endregion

	//#region 定期購入情報の表示仕様
	private displayTrainPassPurchaseInfo(trainPassData: MonthlyCostTrainPassData):string {

        let trainPassPurchaseInfo = '定期(当月)：';

		if (trainPassData.requestStatus === Const.TrainPassStatus.NEW
			|| trainPassData.requestStatus === Const.TrainPassStatus.UNREGISTERED
			|| trainPassData.requestStatus === Const.TrainPassStatus.MAKING
			|| trainPassData.requestStatus === Const.TrainPassStatus.REMAND
		) {
			trainPassPurchaseInfo += '未申請 ';
		}
		else if (trainPassData.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {
			trainPassPurchaseInfo += '承認待 ';
		}
		else if (trainPassData.requestStatus === Const.TrainPassStatus.APPROVED) {

            trainPassPurchaseInfo += '承認済 ';
        } else if (trainPassData.requestStatus === Const.TrainPassStatus.CLOSING) {
            trainPassPurchaseInfo += '締済 ';
        }
        if (trainPassData.requestStatus != Const.TrainPassStatus.NEW
            && trainPassData.requestStatus != null
            && trainPassData.requestStatus != Const.TrainPassStatus.UNREGISTERED
            && trainPassData.requestStatus != Const.TrainPassStatus.REMAND) {
			if (trainPassData.sameLastMonthFlg) {
				trainPassPurchaseInfo += '前月変更無 ';

				if (trainPassData.trainPassPurchaseFlg) {
					trainPassPurchaseInfo += '購入 ';
					if (trainPassData.sameLastRouteFlg) {
						trainPassPurchaseInfo += '経路変更無';
						return trainPassPurchaseInfo;
					} else {
						trainPassPurchaseInfo += '経路変更有';
						return trainPassPurchaseInfo;
					}
				} else {
					trainPassPurchaseInfo += '未購入 ';
					if (trainPassData.sameLastRouteFlg) {
						trainPassPurchaseInfo += '経路変更無';
						return trainPassPurchaseInfo;
					} else {
						trainPassPurchaseInfo += '経路変更有';
						return trainPassPurchaseInfo;
					}
				}
			} else {
				trainPassPurchaseInfo += '前月変更有 ';

				if (trainPassData.trainPassPurchaseFlg) {
					trainPassPurchaseInfo += '購入 ';
					if (trainPassData.sameLastRouteFlg) {
						trainPassPurchaseInfo += '経路変更無';
						return trainPassPurchaseInfo;
					} else {
						trainPassPurchaseInfo += '経路変更有';
						return trainPassPurchaseInfo;
					}
				} else {
					trainPassPurchaseInfo += '未購入 ';
					if (trainPassData.sameLastRouteFlg) {
						trainPassPurchaseInfo += '経路変更無';
						return trainPassPurchaseInfo;
					} else {
						trainPassPurchaseInfo += '経路変更有';
						return trainPassPurchaseInfo;
					}
				}
			}
		}
        return trainPassPurchaseInfo;
    }
	//#endregion

	//#region 
    private displayNextTrainPassPurchaseInfo(trainPassData: MonthlyCostTrainPassData):string {

        let trainPassPurchaseInfo = '定期(翌月)：';

		if (trainPassData.nextMonthRequestStatus === Const.TrainPassStatus.NEW
			|| trainPassData.nextMonthRequestStatus === Const.TrainPassStatus.UNREGISTERED
			|| trainPassData.nextMonthRequestStatus === Const.TrainPassStatus.MAKING
			|| trainPassData.nextMonthRequestStatus === Const.TrainPassStatus.REMAND
		) {
			trainPassPurchaseInfo += '未申請 ';
		}
		else if (trainPassData.nextMonthRequestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {

			trainPassPurchaseInfo += '承認待 '
		}
		else if (trainPassData.nextMonthRequestStatus === Const.TrainPassStatus.APPROVED) {

			trainPassPurchaseInfo += '承認済 ';
		} else if (trainPassData.nextMonthRequestStatus === Const.TrainPassStatus.CLOSING) {
            trainPassPurchaseInfo += '締済 ';
        }

		if (trainPassData.nextMonthRequestStatus != Const.TrainPassStatus.NEW
			&& trainPassData.nextMonthRequestStatus != null
			&& trainPassData.nextMonthRequestStatus != Const.TrainPassStatus.UNREGISTERED
			&& trainPassData.nextMonthRequestStatus != Const.TrainPassStatus.REMAND) {
            if (trainPassData.nextMonthSameLastMonthFlg) {
                trainPassPurchaseInfo += '前月変更無 ';

                if (trainPassData.nextMonthTrainPassPurchaseFlg) {
                    trainPassPurchaseInfo += '購入 ';
                    if (trainPassData.nextMonthSameLastRouteFlg) {
                        trainPassPurchaseInfo += '経路変更無';
                        return trainPassPurchaseInfo;
                    } else {
                        trainPassPurchaseInfo += '経路変更有';
                        return trainPassPurchaseInfo;
                    }
                } else {
                    trainPassPurchaseInfo += '未購入 ';
                    if (trainPassData.nextMonthSameLastRouteFlg) {
                        trainPassPurchaseInfo += '経路変更無';
                        return trainPassPurchaseInfo;
                    } else {
                        trainPassPurchaseInfo += '経路変更有';
                        return trainPassPurchaseInfo;
                    }
                }
            } else {
                trainPassPurchaseInfo += '前月変更有 ';

                if (trainPassData.nextMonthTrainPassPurchaseFlg) {
                    trainPassPurchaseInfo += '購入 ';
                    if (trainPassData.nextMonthSameLastRouteFlg) {
                        trainPassPurchaseInfo += '経路変更無';
                        return trainPassPurchaseInfo;
                    } else {
                        trainPassPurchaseInfo += '経路変更有';
                        return trainPassPurchaseInfo;
                    }
                } else {
                    trainPassPurchaseInfo += '未購入 ';
                    if (trainPassData.nextMonthSameLastRouteFlg) {
                        trainPassPurchaseInfo += '経路変更無';
                        return trainPassPurchaseInfo;
                    } else {
                        trainPassPurchaseInfo += '経路変更有';
                        return trainPassPurchaseInfo;
                    }
                }
			}
		}
        return trainPassPurchaseInfo;
    }
	//#endregion

	//#region ダイアログイベント
	private dialogEvent(reply: string) {
		this.avoidMultipost(async () => {
			if (reply == 'yes') {
				//はいが押された場合
				switch (this.eventNm) {
				case 'apply':
					this.apply()
					break
				case 'cancel':
					this.cancel()
					break
				case 'confirmMonthly':
					this.confirmM()
					break
				case 'confirmDaily':
					this.confirmD()
					break
				case 'approvalMonthly':
					this.approvalM()
					break
				case 'approvalDaily':
					this.approvalD()
						break
				case 'reject':
					this.reject()
						break
					case 'closeMonthly':
						this.closeMonthly()
						break
					case 'cancelClosing':
						this.cancelClosing()
						break
				default:
					break
				}
			} else {
				//いいえが押された場合
				switch (this.eventNm) {
				case 'overwriteTime':
					break
				default:
					break
				}
			}
			//ダイアログを閉じる
			this.dialog = false
			this.eventNm = ''
		})
	}
	//#endregion

	//#region dialog
	//はい・いいえダイアログ
	private openDialog(title: string, msg: string) {
		this.title = title
		this.dialogMsg = msg
		this.dialog = true
	}
	//確認ダイアログ
	private openConfirmationDialog(title: string, msg: string) {
		this.title = title
		this.dialogMsg = msg
		this.confirmationDialog = true
	}
	//#endregion

	//#region エラーメッセージ
	private errorMessage(message: string) {
		this.showMessage = true
		this.messageType = 'error'
		this.message = message
	}
	//#endregion

	//#region メッセージクリア
	private clearMessage() {
		this.message = ''
		this.showMessage = false
        this.snackbarMsg = ''
        this.showSnackbar = false
	}
	//#endregion

	//#endregion
}

